import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImage } from '@fortawesome/pro-solid-svg-icons/faImage';
import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'clsx';

import { Tooltip } from 'ui-components/components/tooltip';
import { TooltipContent } from 'ui-components/components/tooltip/tooltip-content';

import ImageResizerService from '../../services/image-resizer';

import style from '../style.module.less';

const ItemDisplayImage = ({ name = '', productThumbnailUrl, className, shouldShowNoImageIcon = true }) => {
  const [hasImageErrored, setHasImageErrored] = useState(false);
  const [shouldUseFallback, setShouldUseFallback] = useState(false);

  const onImageRetrieveError = useCallback(() => {
    if (!shouldUseFallback) {
      setShouldUseFallback(true);
    } else {
      setHasImageErrored(true);
    }
  }, [shouldUseFallback]);

  if (shouldShowNoImageIcon && (!productThumbnailUrl || hasImageErrored)) {
    return (
      <div className={classnames(style['item-image'], style['empty-image'], className)}>
        <FontAwesomeIcon icon={faImage} />
      </div>
    );
  }
  return (
    <div className={classnames(style['item-image'], className)}>
      <ImageResizerService url={productThumbnailUrl}>
        {({ popoverUrl, thumbnailUrl }) => (
          <Tooltip position='right'>
            <TooltipContent contentClassName={style['tooltip-image-wrapper']}>
              <div className={style['tooltip-image']}>
                <img alt={name} onError={onImageRetrieveError} src={!shouldUseFallback ? popoverUrl : productThumbnailUrl} />
              </div>
            </TooltipContent>
            <img alt={name} onError={onImageRetrieveError} src={!shouldUseFallback ? thumbnailUrl : productThumbnailUrl} />
          </Tooltip>
        )}
      </ImageResizerService>
    </div>
  );
};

ItemDisplayImage.propTypes = {
  name: PropTypes.string,
  productThumbnailUrl: PropTypes.string,
  className: PropTypes.string,
  shouldShowNoImageIcon: PropTypes.bool,
};

export default ItemDisplayImage;
